import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // R�initialise le scroll pour chaque navigation.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

    const root = document.getElementById('root');
    if (root) {
      root.scrollTop = 0;
    }

    document.querySelectorAll('.min-h-screen, [data-scroll-reset]').forEach(el => {
      if (el instanceof HTMLElement) {
        el.scrollTop = 0;
      }
    });
  }, [pathname]);

  return null;
};
